// A new journal post's caret (`LibraryModel.newPostCaret`): New Post writes the journal's opening and sign-off into the post
// (`PlanEditor.newPost`), and Write puts the caret on the empty line between them once it shows the post, without taking
// the keyboard from the title being renamed; Enter there gives the text the keyboard, caret and all.
const pending = new Map<string, { offset: number; focus: boolean }>();

const passing = new Set<(projectId: string, words: number) => void>();

/** Remembers where a new post's caret goes (UTF-16, in its text); nothing for a post that starts empty. With `focus` (no
 *  title being renamed) the text takes the keyboard too. The copy's words aren't written today: the project's day count
 *  (`Writing`, listening through `onNewPostWords`) passes over them. */
export function rememberNewPostCaret(projectId: string, made: { fragmentId: string; caretUTF16: number | null; words: number } | null | undefined,
  focus = false): void {
  if (!made || made.caretUTF16 === null) return;
  pending.set(made.fragmentId, { offset: made.caretUTF16, focus });
  if (made.words) for (const fn of passing) fn(projectId, made.words);
}

export function onNewPostWords(fn: (projectId: string, words: number) => void): () => void {
  passing.add(fn);
  return () => passing.delete(fn);
}

/** The caret waiting for one of these documents, taken once placed. */
export function newPostCaret(ids: readonly string[]): { fragmentId: string; offset: number; focus: boolean } | null {
  for (const id of ids) {
    const waiting = pending.get(id);
    if (waiting) return { fragmentId: id, ...waiting };
  }
  return null;
}

export function placedNewPostCaret(fragmentId: string): void {
  pending.delete(fragmentId);
}
